exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._10dK1uoXDQKYLNPP25Jxcw{width:100%;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", ""]);
// Exports
exports.locals = {
	"container": "_10dK1uoXDQKYLNPP25Jxcw"
};